
function FormatClientNameFilter() {
    return function(client, format) {
        if (!client) return '-';
        return client.name ? 
            client.lastName + ' ' + client.name : client.lastName;
    };
}

export default FormatClientNameFilter;

